import * as React from "react";
import { useTranslation } from "react-i18next";
import Routes from "routing/Routes";
import { Button } from "components/bootstrap";
import { LinkContainer, ReadOnlyFormGroup, Spinner } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import useRoles from "common/hooks/useRoles";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import getDisplayName from "authentication/helpers/getDisplayName";
import convertToSeconds from "authentication/helpers/convertToSeconds";
const ConfigSection = ({ authenticationBackend }) => {
  const { t } = useTranslation("enterprise_authentication");
  const { id, title, description, defaultRoles, defaultUserTimezone, config } = authenticationBackend;
  const { callbackUrl, clientId, clientSecret, tokenVerifierConnectTimeout, type } = config;
  const isOkta = type === OKTA_TYPE_KEY;
  const baseUrl = isOkta ? config.oktaBaseUrl : config.baseUrl;
  const baseUrlLabel = getDisplayName(type);
  const { isLoading, roles } = useRoles();
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: t("oidc.config_section.title"),
      headerActions: /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(id, "server_config") }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, t("oidc.config_section.edit")))
    },
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("oidc.config_section.title_label"), value: title }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("oidc.config_section.description"), value: description }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("oidc.config_section.base_url", { name: baseUrlLabel }), value: baseUrl }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("oidc.config_section.callback_url"), value: callbackUrl }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("oidc.config_section.client_id"), value: clientId }),
    /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("oidc.config_section.client_secret"),
        value: (clientSecret == null ? void 0 : clientSecret.is_set) ? "******" : null
      }
    ),
    /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("oidc.config_section.token_verifier_connect_timeout"),
        value: convertToSeconds(tokenVerifierConnectTimeout)
      }
    ),
    /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("oidc.config_section.default_roles"),
        value: defaultRoles.map((roleId) => {
          var _a;
          return (_a = roles.find((role) => role.id === roleId)) == null ? void 0 : _a.name;
        }).join(", ")
      }
    ),
    /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("oidc.config_section.default_user_time_zone"),
        value: defaultUserTimezone || t("oidc.config_section.browser_time_zone")
      }
    )
  );
};
export default ConfigSection;
